import {gsap} from "gsap";
import {FireInTheHole2} from "../../FireInTheHole2";
import {IFsSymbolData} from "./FreespinSymbol";
import {TimelineSprite} from "@nolimit/slot-launcher/bin/animation/TimelineSprite";
import Spine = PIXI.spine.Spine;
import {SpineTween} from "@nolimit/slot-game/bin/animation/SpineTween";
import {BitmapText} from "pixi.js";
import {FITH2FontConfig} from "../../configs/FITH2FontConfig";
import {FITH2SoundManager} from "../../sound/FITH2SoundManager";

export class ChestSymbol extends PIXI.Sprite {
    private readonly _chest: Spine;
    private _reelId: number = 0;
    private _level: number = 0;
    private _isRevealed: boolean = false;
    private _value: number;
    private _valueText: BitmapText;

    public reset(): void {
        this._isRevealed = false;
        this.value = 0;
        this.symbolSprite = "CC";
    }

    constructor(symbolData: IFsSymbolData) {
        super();
        this._chest = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("chest"));
        this._chest.position.set(0, 0);
        this._isRevealed = symbolData.symName !== "CC";
        this._valueText = new BitmapText("", FITH2FontConfig.FS_COIN_MULTI);
        this._valueText.position.set(0, 0);
        this._valueText.anchor = new PIXI.Point(0.5, 0.5);
        this._valueText.y = 20;
        this.value = this._isRevealed ? symbolData.value! : 0;
        this.symbolSprite = this._isRevealed ? symbolData.symName : "CC";
        this._reelId = symbolData.reelId!;
        this.addChild(this._chest, this._valueText);
    }

    public getDynamite(): gsap.core.Timeline {
        const tl = gsap.timeline(),
            explodeEffect: TimelineSprite = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("W_explde_eff/W_explode_eff_"));
        tl.add(() => {
            this.parent.parent.addChild(this.parent);
                FITH2SoundManager.playDynamiteChestSound();
            }, 0);
        if (!this._isRevealed) {
            this._isRevealed = true;
            this.parent.addChild(this);
            tl.add([
                () => {
                    this._level = 0;
                    this.value = 0;
                },
                new SpineTween(this._chest, 0, "unlock")
            ], 0);
            tl.add(() => {
                this._chest.state.setAnimation(0, "base", true);
            })
        } else {
            tl.add([
                () => {
                    explodeEffect.anchor.set(0.5, 0.5);
                    this.addChild(explodeEffect);
                    FITH2SoundManager.playDynamiteChestSound();
                },
                explodeEffect.getAnimationAutoShowHide()
            ], 0);
            tl.add(() => {
                this.removeChild(explodeEffect);
            });
        }
        return tl;
    }

    public remove(): void {
        if (this._chest) {
            this.removeChild(this._chest);
        }

        if (this.parent) {
            this.parent.removeChild(this);
        }

        this.destroy({children: true});
    }

    public collectStart(): gsap.core.Timeline {
        return gsap.timeline().add([
            gsap.to(this._valueText.scale, 3 * 0.033, {x: 1.4, y: 1.4}),
            new SpineTween(this._chest, 0, "collectstart")
        ]);
    }

    public collect(): gsap.core.Timeline {
        return gsap.timeline().add([
            gsap.to(this._valueText.scale, 5 * 0.033, {x: 1, y: 1}),
            () => {
                FITH2SoundManager.playSound("fsMultiLandsInChest");
                this.value = FireInTheHole2.model.data.coinValues[this._reelId][5]
            },
            new SpineTween(this._chest, 0, "collectend")
        ]).add(() => {
            this._chest.state.setAnimation(0, this._isRevealed ? "base" : "lock", true);
        });
    }

    public set symbolSprite(textureName: string) {
        this._chest.state.setAnimation(0, this._isRevealed ? "base" : "lock", true);

        if (textureName === "CC") {
            this._chest.skeleton.setSkinByName("lv0");
            return;
        }
        const level: number = Math.min(6, Math.ceil(this._value / 50));
        if (this._level === level) {
            return;
        }
        this._level = level;
        this._chest.skeleton.setSkinByName(`lv${level}`)
    }

    public get isRevealed(): boolean {
        return this._isRevealed;
    }

    public set value(value: number) {
        this._value = value;
        this._valueText.text = `${value}x`;
        this._valueText.visible = value > 0;
        this._valueText.scale.set(Math.min(100 / this._valueText.width, 1));
        if (value > 0) {
            this.symbolSprite = "";
        }
    }
}